import React from "react";

import Background from "../../../assets/clothes/clothes-bg.png";

import GamePageLayout from "../GamePageLayout";

const ClothesPage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("clothes-2")}
    >
      이제 길었던 여름도 지나가는구나.
      <br />
      가을 옷도 꺼낼 겸<br />
      옷장 정리나 해볼까?
    </GamePageLayout>
  );
};

export default ClothesPage1;
